module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/mask-13c35d00f560c4506588eea8f74b118c.svg";